import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {Uuid} from '../interface/response/uuid';
import {first} from 'rxjs/operators';
import {ThresholdDictionary} from '../interface/threshold-dictionary';

@Injectable({
  providedIn: 'root'
})
export class ThresholdService {
  public readonly thresholdDictionaryListSubject: ReplaySubject<CountedAndPaginated<ThresholdDictionary>>
    = new ReplaySubject<CountedAndPaginated<ThresholdDictionary>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/threshold-dictionary`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/threshold-dictionary/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;
    }

  }

  public loadList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<ThresholdDictionary>>): void {
    this.httpClient.get(`/rest/crm/threshold-dictionary?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ThresholdDictionary>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.thresholdDictionaryListSubject.next(result);
        }
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/threshold-dictionary/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public deleteConfiguration(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/threshold-dictionary/${uuid}`)
      .pipe(first());
  }

  public configure(uuid: string, formData: any): Observable<any> {
    return this.httpClient.post(`/rest/crm/threshold-dictionary/${uuid}/configure`, formData)
      .pipe(first());
  }
}
